import {
  HeaderBase,
  HeaderBaseProps,
} from "~/landing-pages/components/Header/HeaderBase/HeaderBase";
import { headerContainerStyles } from "~/landing-pages/components/Header/header-shared-styles";
import {
  LandingPageHeaderAlignment,
  LandingPageHeaderOrientation,
} from "~/landing-pages/landing-page-types";

export type HeaderSimpleProps = Omit<HeaderBaseProps, "appearance"> & {
  appearance: "brand" | "dark" | "light";
  textLocation?: LandingPageHeaderOrientation;
  textAlignment?: LandingPageHeaderAlignment;
};

export const HeaderSimple: React.FC<HeaderSimpleProps> = ({
  appearance,
  ...rest
}) => (
  <div className={headerContainerStyles({ appearance })}>
    <HeaderBase appearance={appearance} {...rest} />
  </div>
);
